import React, { useEffect, useState } from 'react';
import { ButtonBase } from '@material-ui/core';
import {
  CreateEntityCommissionSetting,
  GetAllEntityCommissionSettings,
  UpdateLeadExchangePoolConfiguration,
} from '../../../../../Services/LeadXChangeServices/LeadXChangeServices';
import { Spinner } from '../../../../../Components';
import { showError } from '../../../../../Helper';
import { PlusIcon } from '../../../../../assets/icons';

import {
  EntityRevenueFields,
  EntityRevenueTable,
  GlobalSystemBehaviours,
  InfoPoints,
} from './Components';
import FieldWithLabel from '../../../../../Components/FieldWithLabel/FieldWithLabel';
import InfoNoticeBox from '../../Utilities/InfoNoticeBox';

export default function EntityRevenueConfiguration({
  parentTranslationPath,
  entitySources,
  translate,
}) {
  const [entityCommission, setEntityCommission] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    entityCommissionSettingId: null,
    leadXchangeEntitySourceId: null,
    commissionValue: null,
    commissionType: null,
  });
  const [systemBehaviours, setSystemBehaviours] = useState({
    isReturnClosedLeadsToPool: false,
    isAllowReclaimByPreviousAgent: false,
    isAllowMultipleClaimsPerContact: false,
    maxClaimsPerContactPerAgent: null,
  });
  const [selectedValue, setSelectedValue] = useState({
    entitySource: {},
    commissionType: null,
    commissionValue: '',
  });

  const handleAddCampaignCommission = async () => {
    setIsLoading(true);
    setIsSubmitted(true);
    try {
      if (
        systemBehaviours.isAllowMultipleClaimsPerContact &&
        (!systemBehaviours.maxClaimsPerContactPerAgent ||
          systemBehaviours.maxClaimsPerContactPerAgent <= 0)
      ) {
        showError('Please fill all required fields.');
        return;
      }
      await UpdateLeadExchangePoolConfiguration(systemBehaviours);
    } catch {
      showError('Failed to update campaign configuration.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateCampaignCommission = async () => {
    setIsLoading(true);
    try {
      await CreateEntityCommissionSetting(state);
      reload();
    } catch (error) {
      showError(
        error.response.data[0] || 'Failed to create entity commission setting.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  const getAllEntityCommissionSettings = async () => {
    try {
      const res = await GetAllEntityCommissionSettings();
      setEntityCommission(res);
    } catch (error) {
      showError('failed to fetch entity commission settings.');
    }
  };

  const reload = () => {
    setState({
      entityCommissionSettingId: null,
      leadXchangeEntitySourceId: null,
      commissionValue: null,
      commissionType: null,
      systemSourceName: null,
    });
    setSelectedValue({
      entitySource: {},
      commissionType: null,
      commissionValue: '',
    });
    getAllEntityCommissionSettings();
  };

  useEffect(() => {
    getAllEntityCommissionSettings();
  }, []);

  return (
    <div className='leadxchange-config-container'>
      <div className='leadxchange-card-wrapper'>
        <Spinner isActive={isLoading} />

        <div className='leadxchange-card-header'>
          <div className='leadxchange-card-header-wrapper'>
            <span>{translate('entity_revenue_share')}</span>
            <ButtonBase
              className='btns theme-propx solid'
              onClick={handleAddCampaignCommission}
            >
              Save changes
            </ButtonBase>
          </div>
          <span className='field_divider'></span>
        </div>
        <div className='leadxchange-card-content'>
          <EntityRevenueFields
            parentTranslationPath={parentTranslationPath}
            translate={translate}
            entitySources={entitySources}
            setState={setState}
            state={state}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            entityCommission={entityCommission}
          />
          <FieldWithLabel
            hideDivider
            component={
              <div className='leadxchange-data'>
                <button
                  onClick={handleCreateCampaignCommission}
                  className='add-another-wrapper'
                >
                  <PlusIcon
                    width='20'
                    height='20'
                    fill='#475467'
                  />
                  <span className='add-another'>
                    {translate('add_another')}
                  </span>
                </button>
                <EntityRevenueTable
                  parentTranslationPath={parentTranslationPath}
                  translate={translate}
                  entityCommission={entityCommission}
                  setState={setState}
                  state={state}
                  selectedValue={selectedValue}
                  setSelectedValue={setSelectedValue}
                  entitySources={entitySources}
                  setEntityCommission={setEntityCommission}
                  reload={reload}
                />
              </div>
            }
          />
        </div>
        <div className='leadxchange-card-header'>
          <span>{translate('global_system_behaviours')}</span>
          <span className='field_divider'></span>
        </div>
        <GlobalSystemBehaviours
          parentTranslationPath={parentTranslationPath}
          translate={translate}
          systemBehaviours={systemBehaviours}
          setSystemBehaviours={setSystemBehaviours}
          isSubmitted={isSubmitted}
          setIsSubmitted={setIsSubmitted}
        />
      </div>
      <InfoNoticeBox
        infoTitle={'How Entity Revenue Share Works'}
        infoPoints={InfoPoints}
        translate={translate}
        infoTileText={'entity_revenue_info'}
      />
    </div>
  );
}
